import { render, staticRenderFns } from "./CAccordion.vue?vue&type=template&id=58556520&scoped=true&"
import script from "./CAccordion.vue?vue&type=script&lang=ts&"
export * from "./CAccordion.vue?vue&type=script&lang=ts&"
import style0 from "./CAccordion.vue?vue&type=style&index=0&id=58556520&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58556520",
  null
  
)

export default component.exports